export const MINIMUM_PAYMENTS_COUNT = 2;
